import { useRecoilValue } from 'recoil';
import { useEffect } from 'react';
import { authState } from '../recoil/authState';
import useTeeshotApiRequest from './use-teeshotApiRequest';

const useLog = () => {
    const auth = useRecoilValue(authState);
    const { request } = useTeeshotApiRequest();
    useEffect(() => {
        request({ method: 'POST', url: `/club/admin/yearBooking/log` });
    }, [auth]);
};

export default useLog;
